import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-why-platform',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './why-platform.component.html',
  styleUrl: './why-platform.component.scss',
})
export class WhyPlatformComponent {}
